import { useEffect, useState } from 'react'

const LINES = [
  'Knocking on the URL. Anyone home?',
  'Making sure this isn’t a raccoon in a trench coat.',
  'We check it opens — not just that it looks pretty.',
  'No malware. No funny business. Hang tight.',
]

export function DropVerifying() {
  const [line, setLine] = useState(0)

  useEffect(() => {
    const id = window.setInterval(() => {
      setLine((current) => (current + 1) % LINES.length)
    }, 2200)
    return () => {
      window.clearInterval(id)
    }
  }, [])

  return (
    <div
      className="flex flex-col items-center px-4 py-10 text-center sm:px-8 sm:py-14"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="relative mb-8 h-40 w-40" aria-hidden="true">
        <div className="from-primary-container/25 to-secondary-container/20 absolute inset-4 rounded-full bg-gradient-to-br blur-2xl" />
        <svg
          viewBox="0 0 160 160"
          className="relative h-full w-full"
          fill="none"
        >
          <g className="drop-verify-link">
            <path
              d="M58 78c0-10 8-18 18-18h14"
              stroke="#c1c1ff"
              strokeWidth="8"
              strokeLinecap="round"
            />
            <path
              d="M70 98c0 10 8 18 18 18h14"
              stroke="#14d1ff"
              strokeWidth="8"
              strokeLinecap="round"
            />
            <path
              d="M72 80h16"
              stroke="#e5e1e4"
              strokeWidth="8"
              strokeLinecap="round"
            />
            <circle cx="54" cy="72" r="3.5" fill="#c1c1ff" />
            <circle cx="62" cy="70" r="3.5" fill="#c1c1ff" />
            <circle cx="58" cy="76" r="1.6" fill="#131315" />
            <circle cx="66" cy="74" r="1.6" fill="#131315" />
          </g>
          <g className="drop-verify-glass">
            <circle
              cx="112"
              cy="58"
              r="22"
              stroke="#c1c1ff"
              strokeWidth="6"
            />
            <circle cx="112" cy="58" r="14" fill="rgb(193 193 255 / 0.12)" />
            <path
              d="M128 74l16 16"
              stroke="#14d1ff"
              strokeWidth="7"
              strokeLinecap="round"
            />
          </g>
        </svg>
      </div>
      <p className="font-display text-headline-md text-fg">
        Checking the link
      </p>
      <p className="font-body text-body-md text-fg-muted mt-2 max-w-sm">
        Every URL gets a look before it goes live. That&apos;s how claimers
        know they can trust a drop.
      </p>
      <p
        key={line}
        className="font-body text-body-sm text-primary drop-verify-line mt-6 max-w-xs"
      >
        {LINES[line]}
      </p>
      <style>{`
        .drop-verify-link {
          transform-origin: 70px 88px;
          animation: drop-verify-wobble 1.4s ease-in-out infinite;
        }
        .drop-verify-glass {
          transform-origin: 112px 58px;
          animation: drop-verify-scan 1.8s ease-in-out infinite;
        }
        .drop-verify-line {
          animation: drop-verify-fade 2.2s ease-in-out;
        }
        @keyframes drop-verify-wobble {
          0%,
          100% {
            transform: rotate(-6deg) translateY(0);
          }
          50% {
            transform: rotate(7deg) translateY(-4px);
          }
        }
        @keyframes drop-verify-scan {
          0%,
          100% {
            transform: translate(-6px, 4px) rotate(-8deg);
          }
          50% {
            transform: translate(8px, -10px) rotate(10deg);
          }
        }
        @keyframes drop-verify-fade {
          0% {
            opacity: 0;
            transform: translateY(4px);
          }
          12%,
          82% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .drop-verify-link,
          .drop-verify-glass,
          .drop-verify-line {
            animation: none;
          }
        }
      `}</style>
    </div>
  )
}
